<template>
  <div class="waiting-page">
    <div class="container">
      <div v-if="error" class="error-container">
        <div class="error">{{ error }}</div>
        <router-link :to="{ name: 'index' }"> torna alla home</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "IDPCallback",
  data() {
    return {
      code: null,
      loading: true,
      error: null
    };
  },
  beforeMount() {
    this.code = this.$route.query.code;
  },
  async mounted() {
    try {
      this.error = null;
      this.loading = true;
      this.$store.commit("showSpinner");

      const baseUrl = process.env.VUE_APP_API_URL;
      const res = await axios.post(`${baseUrl}/api/v1/idp/login`, {
        code: this.code
      });

      const fanizeAccessToken = res.data.data.token;
      this.intiSession(fanizeAccessToken);
      await this.$store.dispatch("getUserInfo");
      const params = {
        name: "dashboard"
      };
      if (this.$route.query.mobile) {
        params["query"] = { mobile: this.$route.query.mobile === "true" };
        params.query["access_token"] = fanizeAccessToken.access_token;
      }
      // LP ricordarsi di usare la funzione window.location per i redirect mobile nella webview
      if (this.$route.query.mobile === "true") {
        this.loading = false;
        window.location.replace(
          `/dashboard?mobile=true&cookie=false&access_token=${
            fanizeAccessToken.access_token
          }`
        );
      } else {
        this.$router.push(params);
      }
    } catch (e) {
      if (e.hasOwnProperty("response")) {
        console.log(e.response);
        this.error = e.response.data.meta
          ? e.response.data.meta.message
          : e.message;
      } else {
        console.log(e);
        this.error = e.message;
      }
      this.$store.commit("hideSpinner");
    }

    this.loading = false;
  },
  methods: {
    intiSession(token) {
      localStorage.setItem("token", token.access_token);
      this.$store.state.authorization.access_token = token.access_token;
      this.$http.defaults.headers.common["Authorization"] =
        "Bearer " + token.access_token;
      this.$http.defaults.headers["Authorization"] =
        "Bearer " + token.access_token;
      this.$store.state.authorization.expires_in = token.expires_in;
    }
  }
};
</script>
<style lang="scss" scoped>
.waiting-page {
  .container {
    min-height: calc(100vh - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .error-container {
    color: red;
    width: 100%;
    max-width: 640px;
    text-align: center;
    background: #efefef;
    padding: 1rem 2rem;
  }
}
</style>
